/*
 * @Author: 朱占伟
 * @LastEditors: 朱占伟
 * @description: page description
 * @Date: 2021-07-28 10:03:11
 * @LastEditTime: 2021-07-28 10:16:02
 */

import * as echarts from 'echarts/lib/echarts';

// 引入柱状图
import 'echarts/lib/chart/line';

// 引入组件
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/grid';

export default echarts;
